var SpeedControl = 300;

document.querySelector(".site-header__menu-toggle").addEventListener("click", function (e) {
    e.preventDefault();

    var menu = document.querySelector(".site-header .site-header__nav");

    if (!menu.classList.contains("open")) {
        menu.classList.add("open");
        menu.style.display = "block";

        var height = menu.scrollHeight;
        menu.style.height = "0px";

        requestAnimationFrame(function () {
            menu.style.transition = "height " + SpeedControl + "ms ease";
            menu.style.height = height + "px";
        });

        menu.addEventListener("transitionend", function handler() {
            menu.style.height = "auto";
            menu.removeEventListener("transitionend", handler);
        });

        this.classList.add("active");

    } else {

        menu.style.height = menu.scrollHeight + "px";

        requestAnimationFrame(function () {
            menu.style.transition = "height " + SpeedControl + "ms ease";
            menu.style.height = "0px";
        });

        menu.addEventListener("transitionend", function handler() {
            menu.style.display = "none";
            menu.classList.remove("open");
            menu.removeEventListener("transitionend", handler);
        });

        this.classList.remove("active");
    }
});





const hasBeforeFooter = document.querySelector('.before-footer');

if (hasBeforeFooter) {
  const footer = document.querySelector('.site-footer');
  const footerGroup = document.querySelector('.shopify-section-group-footer-group');

  if (footer) {
    const updateFooterSpacing = () => {
      const spacing = footer.offsetHeight + 40;

      hasBeforeFooter.style.paddingBottom = `${spacing}px`;

      if (footerGroup) {
        footerGroup.style.marginTop = `-${spacing}px`;
      }
    };

    updateFooterSpacing();

    const observer = new ResizeObserver(updateFooterSpacing);
    observer.observe(footer);
  }
}

// Delegated so it keeps working after theme editor section reloads
document.addEventListener('click', function (e) {
  const close = e.target.closest('.memorial-hero__promo-close');
  if (close) close.closest('.memorial-hero__promo').hidden = true;
});

// Headings sized for the English word can overflow in translations: [data-fit-text] shrinks to stay on one line
function fitText(el) {
  el.style.fontSize = '';
  const range = document.createRange();
  range.selectNodeContents(el);
  const ratio = range.getBoundingClientRect().width / el.clientWidth;
  if (ratio > 1) el.style.fontSize = parseFloat(getComputedStyle(el).fontSize) / ratio + 'px';
}

function fitAllText() {
  document.querySelectorAll('[data-fit-text]').forEach(fitText);
}

fitAllText();
document.fonts.ready.then(fitAllText);
window.addEventListener('resize', fitAllText);
document.addEventListener('shopify:section:load', fitAllText);

// Header turns solid once the page scrolls
const headerGroup = document.querySelector('.shopify-section-group-header-group');
if (headerGroup) {
  const updateHeader = () => headerGroup.classList.toggle('is-scrolled', window.scrollY > 10);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
}

// Shopify's cookie banner has no Catalan: swap in the theme's text (window.cookieBannerText, set in theme.liquid)
if (window.cookieBannerText) {
  const text = window.cookieBannerText;
  const translateBanner = () => {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner) return false;
    const title = banner.querySelector('#shopify-pc__banner__body-title');
    const link = banner.querySelector('#shopify-pc__banner__body-policy-link');
    if (title) title.textContent = text.title;
    if (link) {
      link.textContent = text.policy;
      const intro = link.parentNode.firstChild;
      if (intro && intro.nodeType === Node.TEXT_NODE) intro.nodeValue = text.body + ' ';
    }
    [['accept', text.accept], ['decline', text.decline], ['manage-prefs', text.manage]].forEach(([id, label]) => {
      const button = banner.querySelector('#shopify-pc__banner__btn-' + id);
      if (button) button.textContent = label;
    });
    return true;
  };
  if (!translateBanner()) {
    const observer = new MutationObserver(() => { if (translateBanner()) observer.disconnect(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }
}
